import React from 'react';
import { RouteProps } from 'react-router-dom';
import { clientMenu, adminMenu, demoPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import CommonHeader from '../pages/_layout/_headers/CommonHeader';
import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';

const headers: RouteProps[] = [
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path, element: null },
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.encryptText.path, element: null },
	{ path: demoPagesMenu.resetPassword.path, element: null },
	{ path: demoPagesMenu.forgotPassword.path, element: null },
	{ path: demoPagesMenu.createAccount.path, element: null },
	// { path: demoPagesMenu.createAccount2.path, element: null },
	// { path: demoPagesMenu.createAccount3.path, element: null },
	{ path: demoPagesMenu.page404.path, element: null },
	{
		path: clientMenu.dashboard.path,
		element: <CommonHeader title={clientMenu.dashboard.text} />,
	},
	// { path: clientMenu.documents.path, element: <CommonHeader title={clientMenu.documents.text} /> },
	{ path: clientMenu.history.path, element: <CommonHeader title={clientMenu.history.text} /> },
	{
		path: clientMenu.analysis.subMenu.chartWidget.path,
		element: <CommonHeader title={clientMenu.analysis.subMenu.chartWidget.text} />,
	},
	{
		path: clientMenu.analysis.subMenu.economicCalendar.path,
		element: <CommonHeader title={clientMenu.analysis.subMenu.economicCalendar.text} />,
	},
	{
		path: clientMenu.analysis.subMenu.ticker.path,
		element: <CommonHeader title={clientMenu.analysis.subMenu.ticker.text} />,
	},
	{
		path: clientMenu.platforms.path,
		element: <CommonHeader title={clientMenu.platforms.text} />,
	},
	{ path: clientMenu.withdraw.path, element: <CommonHeader title={clientMenu.withdraw.text} /> },
	{ path: clientMenu.deposit.path, element: <CommonHeader title={clientMenu.deposit.text} /> },
	{ path: clientMenu.loan.path, element: <CommonHeader title={clientMenu.loan.text} /> },
	{
		path: clientMenu.marginCalculator.path,
		element: <CommonHeader title={clientMenu.marginCalculator.text} />,
	},
	{ path: clientMenu.mail.path, element: <CommonHeader title={clientMenu.mail.text} /> },

	{ path: clientMenu.news.path, element: <CommonHeader title={clientMenu.news.text} /> },

	{
		path: clientMenu.educationcenter.path,
		element: <CommonHeader title={clientMenu.educationcenter.text} />,
	},
	{ path: '/client/recentactivities', element: <CommonHeader title='Recent Activities' /> },

	{ path: adminMenu.dashboard.path, element: <CommonHeader title={adminMenu.dashboard.text} /> },
	{
		path: `${adminMenu.customer.path}/:username`,
		element: <CommonHeader title={adminMenu.customer.text} />,
	},
	{ path: adminMenu.clients.path, element: <CommonHeader title={adminMenu.clients.text} /> },
	{
		path: adminMenu.integrations.subMenu.userCustomData.path,
		element: <CommonHeader title={adminMenu.integrations.subMenu.userCustomData.text} />,
	},
	{ path: adminMenu.leads.path, element: <CommonHeader title={adminMenu.leads.text} /> },
	{path:adminMenu.leads.subMenu.allLeads.path, element:<CommonHeader title={adminMenu.leads.subMenu.allLeads.text} />},
	{ path:adminMenu.leads.subMenu.leadAssignments.path, element:<CommonHeader title={adminMenu.leads.subMenu.leadAssignments.text} />},
	{ path:adminMenu.clickToCall.subMenu.agentMappings.path, element:<CommonHeader title={adminMenu.clickToCall.subMenu.agentMappings.text} />},
	{ path:'/admin/leads/agentMappings', element:<CommonHeader title={adminMenu.clickToCall.subMenu.agentMappings.text} />},
	{ path:adminMenu.clickToCall.subMenu.callHistory.path, element:<CommonHeader title={adminMenu.clickToCall.subMenu.callHistory.text} />},
	{ path:adminMenu.clickToCall.subMenu.dealerCallActivityReport.path, element:<CommonHeader title={adminMenu.clickToCall.subMenu.dealerCallActivityReport.text} />},
	{
		path:adminMenu.marginCall.path,element:<CommonHeader title={adminMenu.marginCall.text} />
	},
	{ path: adminMenu.banks.path, element: <CommonHeader title={adminMenu.banks.text} /> },
	{ path: adminMenu.reports.path, element: <CommonHeader title={adminMenu.reports.text} /> },
	{
		path: adminMenu.reports.subMenu.transactionsReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.transactionsReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.moneyTransactionsReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.moneyTransactionsReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.usersDetailsReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.usersDetailsReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.firstDeposit.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.firstDeposit.text} />,
	},
	{
		path: adminMenu.reports.subMenu.repeatedDeposit.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.repeatedDeposit.text} />,
	},
	{
		path: adminMenu.reports.subMenu.todaysLiquidateAccount.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.todaysLiquidateAccount.text} />,
	},
	{
		path: adminMenu.reports.subMenu.activeAccountsWithFunds.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.activeAccountsWithFunds.text} />,
	},
	{
		path: adminMenu.reports.subMenu.semiInactiveAccounts.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.semiInactiveAccounts.text} />,
	},
	{
		path: adminMenu.reports.subMenu.inactiveAccountsWithFunds.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.inactiveAccountsWithFunds.text} />,
	},
	{
		path: adminMenu.reports.subMenu.topXWinners.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.topXWinners.text} />,
	},
	{
		path: adminMenu.reports.subMenu.topXLoosers.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.topXLoosers.text} />,
	},
	{
		path: adminMenu.reports.subMenu.accountWithoutMoneyTransaction.path,
		element: (
			<CommonHeader title={adminMenu.reports.subMenu.accountWithoutMoneyTransaction.text} />
		),
	},
	{
		path: adminMenu.reports.subMenu.openPositionsReport.subMenu.detailedOpenPositionsReport
			.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.openPositionsReport.subMenu
						.detailedOpenPositionsReport.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.historyReport.subMenu.detailedOpenHistoryReport.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.historyReport.subMenu.detailedOpenHistoryReport.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.historyReport.subMenu.detailedCloseHistoryReport.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.historyReport.subMenu.detailedCloseHistoryReport.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.pendingOrdersReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.pendingOrdersReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.financialStandingReport.subMenu
			.detailedFinancialStandingReport.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.financialStandingReport.subMenu
						.detailedFinancialStandingReport.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.financialStandingReport.subMenu
			.financialStandingHistoryReport.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.financialStandingReport.subMenu
						.financialStandingHistoryReport.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.historyReport.subMenu.detailedCloseHistoryReport.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.historyReport.subMenu.detailedCloseHistoryReport.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.OtpLogsReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.OtpLogsReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.loginReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.loginReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.roboOrdersHistory.subMenu.openRoboOrdersHistory.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.roboOrdersHistory.subMenu.openRoboOrdersHistory.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.roboOrdersHistory.subMenu.closeRoboOrdersHistory.path,
		element: (
			<CommonHeader
				title={
					adminMenu.reports.subMenu.roboOrdersHistory.subMenu.closeRoboOrdersHistory.text
				}
			/>
		),
	},
	{
		path: adminMenu.reports.subMenu.withdrawRequestsReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.withdrawRequestsReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.depositRequestReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.depositRequestReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.clientDepositSummaryReport.path,
		element: (
			<CommonHeader title={adminMenu.reports.subMenu.clientDepositSummaryReport.text} />
		),
	},
	{
		path: adminMenu.reports.subMenu.failedDepositsReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.failedDepositsReport.text} />,
	},

	{
		path: adminMenu.reports.subMenu.loanRequestsReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.loanRequestsReport.text} />,
	},
	{
		path: adminMenu.reports.subMenu.journalReport.path,
		element: <CommonHeader title={adminMenu.reports.subMenu.journalReport.text} />,
	},
	{ path: adminMenu.withdraw.path, element: <CommonHeader title={adminMenu.withdraw.text} /> },
	{ path: adminMenu.deposit.path, element: <CommonHeader title={adminMenu.deposit.text} /> },
	{ path: adminMenu.loan.path, element: <CommonHeader title={adminMenu.loan.text} /> },
	{ path: adminMenu.mail.path, element: <CommonHeader title={adminMenu.mail.text} /> },
	{
		path: adminMenu.educationcenter.path,
		element: <CommonHeader title={adminMenu.educationcenter.text} />,
	},
	{
		path: adminMenu.analysis.subMenu.chartWidget.path,
		element: <CommonHeader title={adminMenu.analysis.subMenu.chartWidget.text} />,
	},
	{
		path: adminMenu.analysis.subMenu.economicCalendar.path,
		element: <CommonHeader title={adminMenu.analysis.subMenu.economicCalendar.text} />,
	},
	{
		path: adminMenu.analysis.subMenu.ticker.path,
		element: <CommonHeader title={adminMenu.analysis.subMenu.ticker.text} />,
	},
	{
		path: adminMenu.otpService.path,
		element: <CommonHeader title={adminMenu.otpService.text} />,
	},
	{
		path: adminMenu.transactionalSmsProviders.path,
		element: <CommonHeader title={adminMenu.transactionalSmsProviders.text} />,
	},
	// {
	// 	path: adminMenu.publicSettings.path,
	// 	element: <CommonHeader title={adminMenu.publicSettings.text} />,
	// },

	{ path: '/admin/recentactivities', element: <CommonHeader title='Recent Activities' /> },

	{
		path: `*`,
		element: <DefaultHeader />,
	},
];

export default headers;
